import { createSlice } from "@reduxjs/toolkit";


interface InitialStateModel {
  viewingModes: "cart" | "map" | "list";
  mapCenter:any
  filter: any;
  selectedAdvertIdPreview:null |string
  isShowAdvertPreview:boolean;
}

const InitialState: InitialStateModel = {
  viewingModes: "list",
  mapCenter:{
    lat: 38.733509, // Kayseri coordinates
    lng: 35.485397,
  },
  selectedAdvertIdPreview:null,
  isShowAdvertPreview:false,
  filter: {
    PageIndex: 1,

    PageSize: 20,


  IsSearchFilter:false,
    IncludeProperties: [
      "User",
    "Store",
      "Currency",
      "Country",
      "City",
      "District",
      "Neighbourhood",
      "AdvertMedia",
      "AdvertMedia.Media",
      "AdvertContactType",
      "AdvertContactType.ContactType",
       "User.UserPackage",
       "User.UserPackage.Package",
       
    ],
    SortProperty: "price",
    SortType: "asc",
  },
};
      // "AdvertOptionAttr",
const realStateSlice = createSlice({
  name: "realStateSlice",
  initialState: InitialState,
  reducers: {
    hanldleSetRealStateViewingMode: (state, action) => {
      let data = action.payload;
      state.viewingModes = data.viewingMode;
    },
    handleSetAdvertListFilter: (state, action) => {
      state.filter = action.payload.filter;
    },
    handleSetMapCenter: (state, action) => {
      state.mapCenter = action.payload.data;
    },
    handleSetIsShowAdvertPreview: (state, action) => {
      state.isShowAdvertPreview = action.payload.status;
    },
    handleSetSelectedAdvertIdPreview: (state, action) => {
  state.selectedAdvertIdPreview = action.payload.id;
},

   handleResetAdvertListFilter: (state) => {
  const {
    CategoryId,
    categoryContainer,
    categoryUrl,
    categoryType,
    categoryDisplayUrl,
    categoryDescription,
    mainCategoryOptionId
  } = state.filter;

  state.filter = {
    PageIndex: 1,
    PageSize: 20,
    mainCategoryOptionId,  // Kategori seçimini KORU
    IsSearchFilter: false,
    IncludeProperties: [
      "User",
      "Store",
      "Currency",
      "Country",
      "City",
      "District",
      "Neighbourhood",
      "AdvertMedia",
      "AdvertMedia.Media",
      "AdvertContactType",
      "AdvertContactType.ContactType",
    ],
    SortProperty: "price",
    SortType: "asc",
    CategoryId,
    categoryContainer,
    categoryUrl,
    categoryType,
    categoryDisplayUrl,
    categoryDescription,
  };
},

    
  },
});

export const {
  hanldleSetRealStateViewingMode,
  handleResetAdvertListFilter,
  handleSetAdvertListFilter,
  handleSetMapCenter,
  handleSetIsShowAdvertPreview,
  handleSetSelectedAdvertIdPreview,
} = realStateSlice.actions;
export default realStateSlice;
